const VARIANT_WHITE = "white";
const VARIANT_PRIMARY = "primary";

export default {
  props: {
    variant: {
      type: String,
      required: false,
      default: VARIANT_PRIMARY,
      validator: value => [VARIANT_PRIMARY, VARIANT_WHITE].indexOf(value) >= 0,
    },
  },
  computed: {
    variantClass() {
      return { [`form-variant-${this.variant}`]: this.variant };
    },
  },
};
